import { ErrorFallback } from "@/components";
import SingleNewsCard from "./SingleNewsCard";
import { siteRoutes } from "@/routes/siteRoutesList";
import useSingleZone from "@/features/zones/hooks/useSingleZone";
import { Spinner } from "@radix-ui/themes";

export const AllNewsItem = (
  news: any,
  _loading_news: boolean,
  zone?: string
) => {
  const slug = zone
    ? `${siteRoutes["zone"]}${zone}${siteRoutes["newsAndSlug"]}${news.slug}`
    : `${siteRoutes["newsAndSlug"]}${news.slug}`;

  try {
    return (
      <SingleNewsCard
        imageURL={news.imageURL}
        title={news.title}
        created={news.created}
        slug={slug}
        isFavoriteByCurrentUser={news.isFavoriteByCurrentUser}
        trending={news.trending}
        isPlaceholder={_loading_news}
        author={news.author}
        isFeatured={news.isFeatured}
        intro={news.intro}
        keywords={news.keywords}
        zone={news.zone}
      />
    );
  } catch {
    return <ErrorFallback>Failed to load news</ErrorFallback>;
  }
};
